import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { downloadTraxxasModelsForecast } from '../utils/traxxasModelsReport';

// Reports & Excel Stuff -- each card builds a report and downloads it straight
// away, no page of its own. Add new reports to REPORTS.
const REPORTS = [
  {
    key:         'traxxas-models',
    icon:        '📥',
    title:       'Download Traxxas Models Forecast',
    description: 'Every Traxxas RC model with stock on hand or incoming — sold last 12 months, 6-month sales forecast and forecast SOH. Excel.',
    accent:      'green',
    run:         downloadTraxxasModelsForecast,
  },
];

const Reports = () => {
  const navigate = useNavigate();
  const [busy, setBusy]       = useState(null);
  const [message, setMessage] = useState(null);

  const run = async (report) => {
    setBusy(report.key);
    setMessage(null);
    try {
      const rows = await report.run();
      setMessage({ ok: true, text: `${report.title}: downloaded (${rows} rows).` });
    } catch (err) {
      setMessage({ ok: false, text: `${report.title} failed: ${err.message || err}` });
    } finally {
      setBusy(null);
    }
  };

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/')}>← Home</button>
        <span className="page-nav__title">Reports &amp; Excel Stuff</span>
      </div>

      <div className="home-greeting">
        <p className="home-greeting__sub">Click a report to download it</p>
      </div>
      {message && (
        <p style={{ color: message.ok ? '#4ade80' : '#f87171', margin: '0 0 16px' }}>
          {message.text}
        </p>
      )}
      <div className="home-cards">
        {REPORTS.map((r) => (
          <button
            key={r.key}
            className={`home-card home-card--${r.accent}`}
            onClick={() => run(r)}
            disabled={busy !== null}
          >
            <div className="home-card__icon">{r.icon}</div>
            <div className="home-card__body">
              <div className="home-card__title">{r.title}</div>
              <div className="home-card__desc">{r.description}</div>
            </div>
            <div className="home-card__arrow">{busy === r.key ? 'Building…' : 'Download'}</div>
          </button>
        ))}
      </div>
    </main>
  );
};

export default Reports;
